export default function PageTitle({ title }: { title: string | React.ReactNode }) {
  return <h2 className="text-3xl tracking-tight text-slate-900 dark:text-white sm:text-4xl print:hidden">{title}</h2>;
}
